import {SVG} from "@game/ui/images";
import cn from "classnames";

export const WinRays = () => (
    <div className={cn("popup__win-rays")}>
        <SVG.WinRays />
    </div>
);
